import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication/authentication.service';

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.scss']
})
export class AdminLoginComponent implements OnInit {
  email = '';
  password = '';

  errorMessage = '';
  isLoading = false;

  constructor(
    private auth: AuthenticationService,
    private router: Router
  ) { }

  loadPageData(): void { }

  login(): void {
    this.errorMessage = '';

    if (!this.email || !this.email.trim()) {
      this.errorMessage = 'Please enter your admin email address.';
      return;
    }

    if (!this.password || !this.password.trim()) {
      this.errorMessage = 'Please enter your password.';
      return;
    }

    this.isLoading = true;

    this.auth.adminLogin(this.email.trim(), this.password).subscribe({
      next: () => {
        this.isLoading = false;
        this.router.navigate(['/admin/dashboard']);
      },
      error: (error) => {
        this.isLoading = false;

        if (error?.status === 401 || error?.status === 400) {
          this.errorMessage = 'Invalid admin email address or password. Please try again.';
          return;
        }

        if (error?.status === 403) {
          this.errorMessage = 'You do not have permission to access the admin portal.';
          return;
        }

        if (error?.error?.message) {
          this.errorMessage = error.error.message;
          return;
        }

        this.errorMessage = 'Admin login failed. Please check your details and try again.';
      }
    });
  }

  clearError(): void {
    if (this.errorMessage) {
      this.errorMessage = '';
    }
  }

  ngOnInit(): void {
    this.loadPageData();
  }
}